const CustomFields = {
  TYPES: {
    DOCK: 'dock',
    GATE: 'gate',
    USER: 'user',
    DEPOT: 'depot',
    INDENT: 'indent',
    CONSIGNEE: 'consignee',
    INVOICE: 'invoice',
    INVOICE_RETURN_REASON: 'invoice_return_reason',
    INDENT_MATERIALS: 'indent_materials',
    EXIM_DOCUMENT_FIELDS: 'exim_document_fields',
    EMPTY_CONTAINER_FIELDS: 'empty_container_fields',
    IMPORT_MASTER_INDENT_CUSTOM_FIELD: 'import_master_indent_custom_field',
    RATE_MATRIX: 'rate_matrix',
    EXPORT_MASTER_INDENT_CUSTOM_FIELD: 'export_master_indent_custom_field',
    INVOICE_CUSTOM_FIELD: 'invoice_custom_fields',
    TRANSPORTER: 'transporter',
    DEDICATED_TRUCK: 'dedicatedtruck',
    INDENT_SOURCE: 'indent_source',
    INDENT_DESTINATION: 'indent_destination',
    INVOICE_MATERIAL_LEVEL_CUSTOM_FIELDS: 'invoice_material_level_custom_fields',
    SHARE_OF_BUSINESS: 'share_of_business',
    DETENTION: 'detention',
  },
  FIELD_TYPES: {
    DATE: 'date',
    NUMBER: 'number',
    TEXTBOX: 'textbox',
    CHECKBOX: 'checkbox',
    DROPDOWN: 'dropdown',
    SINGLE_SELECT: 'single_select',
    TEXT: 'text',
    ATTACHMENT: 'attachment',
  },
};

module.exports = CustomFields;
